import { Box } from '@bpba/ui-components';
import styled from 'styled-components';

export const GlassBox = styled(Box)`
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(14px) saturate(130%);
  -webkit-backdrop-filter: blur(14px) saturate(130%);

  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
`;
